export default {
    promiles_request_title: "Solicitud de Promiles",
    promiles_request_account: "Cuenta",
    promiles_request_date_range: "Rango de Fechas",
    promiles_request_send_request: "Enviar Solicitud",
    promiles_request_success_message: "Solicitud de Promiles enviada con éxito",
    promiles_request_error_message: "Solicitud de Promiles no enviada debido a error",
}